import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { SelectCustom } from "../../../../ui/molecules/select"
import { ResultControlComplianceOptions } from "../../../../utils"
import { GetAllResultControlActivity, resetGetAllRCAStatus, resetRCAUpdateRequest, resetRCAUpdateSatus, ResultControlActivityUpdate, setRCAIdToUpdate, setRCAUpdateBlockedEvaluation, setRCAUpdateCheckProcessingActivity, setRCAUpdateCustomerBillingWorksheetId, setRCAUpdateEvaluationDate, setRCAUpdateEvaluationNote, setRCAUpdateImportationActivityResult, setRCAUpdateLivestockActivityResult, setRCAUpdateNote, setRCAUpdateOfficerId, setRCAUpdateProcessingActivityResult, setRCAUPdateRequest, setRCAUpdateServiceTypecode, setRCAUpdateUnitEmployed, setRCAUpdateVegetalActivityResult } from "../../slice"
import { ResultControlActivityUpdateDTO } from "../../dataservice/dto"
import { SingleCheckbox } from "../../../../ui/molecules/SingleCheckbox"
import { Calendar } from "../../../../ui/molecules/calendar"
import TextArea from "../../../../ui/molecules/textArea"
import { GetAllCustomerBillingWorksheet, resetGetAllCustomerBWStatus } from "../../../schedaCalcolo/slice"
import { Banner } from "../../../../ui/organisms/banner"
import { HoursMinutesBox } from "../../../schedaCalcolo/components/hoursMinutes"
import Button from "../../../../ui/molecules/button"
import { format } from "date-fns"

interface Props {
    close: () => void
}

export function ResultControlActivityEdit(props: Props) {
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const userState = useAppSelector(state => state.users)
    const billingAndServiceState = useAppSelector(state => state.billingAndServiceType)
    const [blockedFlag, setBlockedFlag] = useState<boolean>(false)
    const [preparationFlag, setPreparationFlag] = useState<boolean>(false)

    useEffect(() => {
        dispatch(GetAllResultControlActivity({
            itemsPerPage: 0,
            page: 0,
            inspectionVisitId: assignmentState.rcaIVId
        }))
        dispatch(GetAllCustomerBillingWorksheet({
            itemsPerPage: 0,
            page: 0,
            customerId: assignmentState.rcaIVCustomerId,
            year: assignmentState.getAssignmentByIdResponse?.year
        }))
        dispatch(setRCAUpdateOfficerId(userState.findMeResponse.id))
    }, [])

    useEffect(() => {
        if (assignmentState.getAllRcaStatus === 'successfully' &&
            assignmentState.getAllRcaResponse !== undefined
        ) {
            dispatch(resetGetAllRCAStatus())
            const data = assignmentState.getAllRcaResponse.data[0]
            dispatch(setRCAIdToUpdate(data.id))
            dispatch(setRCAUPdateRequest({
                vegetalActivityResult: data.vegetalActivityResult,
                processingActivityResult: data.processingActivityResult,
                livestockActivityResult: data.livestockActivityResult,
                importationActivityResult: data.importationActivityResult,
                blockedEvaluation: data.blockedEvaluation,
                evaluationDate: data.evaluationDate,
                evaluationNote: data.evaluationNote,
                checkProcessingActivity: data.checkProcessingActivity,
                note: data.note,
                serviceTypecode: data.serviceTypecode,
                unitEmployed: data.unitEmployed,
                customerBillingWorksheetId: data.customerBillingWorksheetId,
                officerId: data.officerId
            } as ResultControlActivityUpdateDTO))
        }
    }, [assignmentState.getAllRcaStatus])

    useEffect(() => {
        const req = assignmentState.rcaUpdateRequest
        setBlockedFlag(req.blockedEvaluation !== undefined ? req.blockedEvaluation : false)
        setPreparationFlag(req.checkProcessingActivity !== undefined ? req.checkProcessingActivity : false)
    }, [assignmentState.rcaUpdateRequest])

    useEffect(() => {
        if (billingAndServiceState.getAllCustomerBillingWorksheetStatus === 'successfully' &&
            billingAndServiceState.getAllCustomerBillingWorksheetResponse !== undefined
        ) {
            const response = billingAndServiceState.getAllCustomerBillingWorksheetResponse
            dispatch(resetGetAllCustomerBWStatus())
            dispatch(setRCAUpdateCustomerBillingWorksheetId(
                response.data.length > 0 ?
                    response.data[0].id :
                    undefined
            ))

        }
    }, [billingAndServiceState.getAllCustomerBillingWorksheetStatus])

    useEffect(() => {
        if (assignmentState.rcaUpdateStatus === 'successfully') {
            props.close()
        }
    }, [assignmentState.rcaUpdateStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5">
                <div className="assignment-subtitle text-left pb-5">
                    Attività oggetto di controllo e valutazione
                </div>
                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Esito attività di produzione vegetale (Av)
                        </div>
                        <SelectCustom
                            placeholder="Seleziona esito..."
                            options={ResultControlComplianceOptions}
                            value={assignmentState.rcaUpdateRequest.vegetalActivityResult}
                            onChange={(value) => dispatch(setRCAUpdateVegetalActivityResult(value))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Esito attività di preparazione (B)
                        </div>
                        <SelectCustom
                            placeholder="Seleziona esito..."
                            options={ResultControlComplianceOptions}
                            value={assignmentState.rcaUpdateRequest.processingActivityResult}
                            onChange={(value) => dispatch(setRCAUpdateProcessingActivityResult(value))}
                        />
                    </div>
                </div>

                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Esito attività di produzione zootecnica (Az)
                        </div>
                        <SelectCustom
                            placeholder="Seleziona esito..."
                            options={ResultControlComplianceOptions}
                            value={assignmentState.rcaUpdateRequest.livestockActivityResult}
                            onChange={(value) => dispatch(setRCAUpdateLivestockActivityResult(value))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Esito attività di importazione (C)
                        </div>
                        <SelectCustom
                            placeholder="Seleziona esito..."
                            options={ResultControlComplianceOptions}
                            value={assignmentState.rcaUpdateRequest.importationActivityResult}
                            onChange={(value) => dispatch(setRCAUpdateImportationActivityResult(value))}
                        />
                    </div>
                </div>

                <div className="assignment-subtitle text-left pb-5 pt-5">
                    Valutazione
                </div>


                <div className="pb-5" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <div className="assignment-text-content text-left">
                        Valutazione bloccata in attesa di integrazioni dal Tecnico Ispettore
                    </div>
                    <SingleCheckbox
                        label=''
                        checked={blockedFlag}
                        setChecked={(value) => {
                            dispatch(setRCAUpdateBlockedEvaluation((value)))
                            setBlockedFlag(value)
                        }}
                    />
                </div>

                <div className="pb-5">
                    <div className="assignment-text-content text-left">
                        Data Valutazione
                    </div>
                    <Calendar
                        selected={assignmentState.rcaUpdateRequest.evaluationDate}
                        onChange={(date) => dispatch(setRCAUpdateEvaluationDate(format(new Date(format(new Date(date), 'yyyy-MM-dd')), 'yyyy-MM-dd')))}
                    />
                </div>

                <div className="pb-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                    <div className="assignment-text-content text-left">
                        Note
                    </div>
                    <TextArea
                        value={assignmentState.rcaUpdateRequest.evaluationNote}
                        onChangeText={(text) => dispatch(setRCAUpdateEvaluationNote(text))}
                    />
                </div>

                <div className="assignment-subtitle text-left pb-5 pt-5">
                    Verifica Preparazioni Biologiche
                </div>

                <div className="pb-5" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <div className="assignment-text-content text-left">
                        Verifica attività di preparazione
                    </div>
                    <SingleCheckbox
                        label=''
                        checked={preparationFlag}
                        setChecked={(value) => {
                            dispatch(setRCAUpdateCheckProcessingActivity((value)))
                            setPreparationFlag(value)
                        }}
                    />
                </div>

                <div className="pb-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                    <div className="assignment-text-content text-left">
                        Note
                    </div>
                    <TextArea
                        value={assignmentState.rcaUpdateRequest.note}
                        onChangeText={(text) => dispatch(setRCAUpdateNote(text))}
                    />
                </div>

                {
                    assignmentState.rcaUpdateRequest.customerBillingWorksheetId === undefined && (
                        <div className="gap-[8px] mt-5 text-left bg-red-200" style={{ margin: '24px', borderRadius: '8px' }}>
                            <span className="text-red-800 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                                Scheda di calcolo non disponibile per il {assignmentState.getAssignmentByIdResponse?.year}
                            </span>
                        </div>
                    )
                }

                {
                    assignmentState.rcaUpdateRequest.customerBillingWorksheetId && (
                        <div className="pt-5">
                            <HoursMinutesBox
                                defaultValue={Number(assignmentState.rcaUpdateRequest.unitEmployed)}
                                onChange={(value) => {
                                    dispatch(setRCAUpdateServiceTypecode('att_ctr3_10'))
                                    dispatch(setRCAUpdateUnitEmployed(value))
                                }}
                            />
                        </div>
                    )
                }
            </div>


            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        props.close();
                        dispatch(resetRCAUpdateRequest())
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => {
                            dispatch(ResultControlActivityUpdate({ body: assignmentState.rcaUpdateRequest, id: assignmentState.rcaIdToUpdate }))
                        }
                        }

                    />
                </div>
            </div>
        </div>
    )
}